// extracted by mini-css-extract-plugin
export default {"item_wrapper":"product-banners-form_item_wrapper__vAOLI","items_container":"product-banners-form_items_container__9Z3CV"};